<template>
  <div class="container-fluid">
    <div>
      <div class="card">
        <div id="topo" class="card-header">
          <div class="row">
            <div class="col col-xs-2">
              <h4 class="panel-title">
                <span class="title"
                  >TSE - Geração de arquivo de Notas Fiscais</span
                >
                <br />
                <span class="navigation">Nota Fiscal > Arquivo de Notas TSE</span>
              </h4>
            </div>
          </div>
        </div>
        <div class="card-body">
          <error-list :erros="erros" />

          <div class="row">
            <div class="col-md-4 col-lg-2 mb-3">
              <span class="p-fluid">
                <CustomCalendar
                  id="dataIni"
                  name="dataIni"
                  v-model="dataInicial"
                  :showIcon="true"
                  dateFormat="dd/mm/yy"
                  placeholder="Data Emissão Inicial"
                  @keyup.enter="geraArquivo"
                />
              </span>
            </div>
            <div class="col-md-4 col-lg-2 mb-3">
              <span class="p-fluid">
                <CustomCalendar
                  id="dataFim"
                  name="dataFim"
                  v-model="dataFinal"
                  :showIcon="true"
                  dateFormat="dd/mm/yy"
                  placeholder="Data Emissão Final"
                  @keyup.enter="geraArquivo"
                />
              </span>
            </div>
          </div>

          <div class="mb-2">
            <Button
              @click="geraArquivo()"
              label="Gerar Arquivo"
              type="button"
              class="p-button-primary mr-2"
              icon="pi pi-search"
              :disabled="loading"
            />
          </div>
          <hr />
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import TseService from "../services/nfse/tse.service";
import money from "../conf/config.money";
import CustomCalendar from "../components/global/CustomCalendar.vue";

export default {
  name: "TseArquivoNF",

  components: {
    CustomCalendar
  },

  data() {
    return {
      money: money,
      inativo: false,
      display: false,
      loading: false,
      dataInicial: null,
      dataFinal: null,
      erros: []
    };
  },

  mounted() {
    //document.getElementById("dataIni").focus();
  },

  created() {
  },

  methods: {
    processando(show) {
      if (show) {
        this.loading = true;
        this.$root.$emit("loading:show");
      } else {
        this.loading = false;
        this.$root.$emit("loading:hide");
      }
    },

  geraArquivo() {
      if (!this.dataInicial) {
        this.$root.$emit("alert:warn", "Data de emissão inicial não informada!");
        return;
      }
      if (!this.dataFinal) {
        this.$root.$emit("alert:warn", "Data de emissão final não informada!");
        return;
      }      
      this.processando(true);

      TseService.downloadArquivoNF(this.dataInicial, this.dataFinal)
        .then(
          data => {
            console.log(data);
          },
          error => {
            let errorMessage = "Erro ao gerar o arquivo.";
            if (error.response) {
              errorMessage = error.response.data;
            }
            console.log(error);
            this.$toast.add({
              severity: "error",
              summary: errorMessage
            });
            //this.$root.$emit("alert:warn", "Erro ao efetuar o download!");
            //console.log(error);
          }
        )
        .then(() => {
          this.processando(false);
        });      
    }
  },
  computed: {}
};
</script>

<style scoped>
</style>
